<script lang="ts">
    import { type Snippet, onMount, untrack } from 'svelte';
    import Esi from '@shared/components/esi/Esi.svelte';
    import {
        type ComparisonContext,
        setComparisonContext,
    } from '@shared/providers/comparison-context/ComparisonContext.browser.ts';
    import type { Variation } from '@shared/types/types.ts';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';
    import {
        type ComparisonCoordinator,
        injectProviderComposition,
    } from '@tilelist/components/ProviderComposition.svelte.ts';

    interface Props {
        comparisonId?: string;
        showComparisonOverride?: boolean;
        children: Snippet;
    }

    const { comparisonId, showComparisonOverride, children }: Props = $props();

    let { onex, browser: wiring } = $derived(injectWiring());
    const composition = injectProviderComposition();
    let showComparison = $state(false);
    const comparisonEnabled = $derived(!onex.isToggleActive('EMERGENCY_DISABLE_PRODUCT_COMPARISON'));

    const comparisonState = $state<ComparisonContext>({
        get comparisonId() {
            return comparisonId || null;
        },
        initialized: false,
        get showComparison() {
            return showComparisonOverride ?? showComparison;
        },
        set showComparison(value: boolean) {
            showComparison = value;
        },
        selectedVariations: [],
        compareLink: null,
        async selectVariation(variation: Variation) {
            await pandaComparison.selectVariation(comparisonState, variation);
        },
        async deselectVariation(id: string) {
            await pandaComparison.deselectVariation(comparisonState, id);
        },
        async clearSelectedVariations() {
            await pandaComparison.clearSelectedVariations(comparisonState);
        },
    });
    setComparisonContext(comparisonState);

    /*               */
    let pandaComparison: ComparisonCoordinator;

    /**
 *
 *
 */
    let lastComparisonId = $state(untrack(() => comparisonId));
    $effect(() => {
        if (!comparisonId || !comparisonEnabled) return;

        if (!pandaComparison && wiring) {
            pandaComparison = composition.createComparisonCoordinator(
                wiring.variationLoadingService,
                wiring.trackingService,
                wiring.eventsIncoming,
            );
            pandaComparison.initialize(comparisonState);
        }
        if (comparisonId !== lastComparisonId) {
            pandaComparison.updateContext(comparisonState);
            lastComparisonId = comparisonId;
        }
    });

    onMount(() => () => pandaComparison?.dispose());
</script>

{#if comparisonEnabled}
    <Esi src="/dcs/product-comparison-api" />
{/if}

{@render children()}
